
<template>
<div>
  <is-loading v-if="isLoading" />
  <div v-else class="row account-page g-4">
    <div class="col-md-4 order-md-2">
      <div class="card overflow-hidden position-sticky" style="top: 90px;">
        <div class="bg-primary py-4">
        </div>
        <div class="card-body text-center">
          <a href="javascript:void(0)" class="avatar rounded-circle avatar-lg card-avatar card-avatar-top">
            <img :src="absoluteUrl(activeUser.image)" 
              @click="showProfileImg(activeUser.image)"
              class="avatar-img rounded-circle border border-4 border-card"
             :alt="activeUser.first_name">
          </a>
          <small>
            <span class="text-success">●</span> Online
          </small>
          <h3 class="card-title">
            <a href="javascript:void(0)">{{activeUser.first_name}} {{activeUser.last_name}}</a>
          </h3>
          <p v-if="activeUser.role" class="small text-muted mb-0">
            <span class="badge bg-primary text-capitalize">{{activeUser.role.name}}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="col-lg-8">
      <div class="card h-100">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h5 class="card-title mb-0">Your Account Details</h5>
          <div class="dropdown dropstart no-arrow">
            <button class="dropdown-toggle btn btn-sm btn-light" type="button"
              role="button" data-bs-toggle="dropdown" aria-expanded="false">
              <i class="ri-more-2-fill"></i>
            </button>
            <ul class="dropdown-menu">
              <li>
                <button @click="popupProfileShow = true" class="dropdown-item"
                type="button" >
                  Update profile </button>
              </li>
              <li>
                <button @click="popupPasswordShow = true" class="dropdown-item"
                type="button" >
                  Update password </button>
              </li>
            </ul>
          </div>
        </div>
        <div class="card-body position-relative">
          <div  class="row g-4"> 
            <div class="col-sm-6">
              <label class="small text-muted">First Name</label>
              <p class="mb-0">{{ activeUser.first_name }}</p>
            </div>
            <div class="col-sm-6">
              <label class="small text-muted">Middle Name</label>
              <p class="mb-0">{{ activeUser.middle_name }}</p>
            </div>
            <div class="col-sm-6">
              <label class="small text-muted">Last Name</label>
              <p class="mb-0">{{ activeUser.last_name }}</p>
            </div>
            <div class="col-sm-6">
              <label class="small text-muted">Email</label>
              <p class="mb-0">{{ activeUser.email }}</p>
            </div>
            <div class="col-sm-6">
              <label class="small text-muted">Phone</label>
              <p class="mb-0">{{ activeUser.mobile }}</p>
            </div>
            <div class="col-sm-6">
              <label class="small text-muted">Gender</label>
              <p class="mb-0">{{ activeUser.gender }}</p>
            </div>
            <div class="col-sm-6">
              <label class="small text-muted">National Identification Number (NIN)</label>
              <p class="mb-0">{{ activeUser.candidate.nin }}</p>
            </div>
            <div class="col-sm-6">
              <label class="small text-muted">Voter Identification Number (VIN)</label>
              <p class="mb-0">{{ activeUser.candidate.vin}}</p>
            </div>
            <div class="col-sm-6">
              <label class="small text-muted">Registered On</label>
              <p class="mb-0">{{ $filters.date(activeUser.created_at) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <b-modal size="lg" v-model="popupProfileShow" hide-footer centered
    title="Update profile" body-class="loading-viewport"
    title-class="fs-6" @hide="initializeAll()">
    <account-profile-form v-if="popupProfileShow" @closeMe="initializeAll()"
    :editItem="activeUser" :editMode="true" @updatedItem="fetchItem(false)"/>
  </b-modal>

  <b-modal size="lg" v-model="popupPasswordShow" hide-footer centered
    title="Update profile" body-class="loading-viewport"
    title-class="fs-6" @hide="initializeAll()">
    <account-password-form v-if="popupPasswordShow" @closeMe="initializeAll()"
    :editItem="activeUser" :editMode="true"/>
  </b-modal>
</div>
</template>

<script>
import IsLoading from '@/components/IsLoading.vue'
import AccountProfileForm from '@/components/forms/AccountProfileForm.vue'
import AccountPasswordForm from '@/components/forms/AccountPasswordForm.vue'

export default {
  name: "user-edit",
  components: {
    IsLoading,
    AccountPasswordForm,
    AccountProfileForm,
  },
  data(){
    return {
      isLoading: true,
      popupProfileShow: false,
      popupPasswordShow: false
    }
  },
  computed: {
    activeUser(){
      return this.$store.state.AppActiveUser
    },
  },
  methods:{
    fetchItem(showLoader = true){
      this.isLoading = showLoader;
      this.$store.dispatch("fetchActiveUser")
        .then((response) => {
          this.isLoading = false
          if(!response.data.success){
            this.$router.push({path: '/error-404'})
          }
      })
    },
    initializeAll(){
      this.popupProfileShow = false;
      this.popupPasswordShow = false
    }
  },
  created() {
    this.fetchItem()
  },
}

</script>
<style scoped>
.user-photo{
 width:10rem;
}
</style>
